import React, { useState } from 'react'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css"
import data from './data'


const Slider = () => {
    const[state, setState] = useState(false)
    const toggleState = () =>{
      setState(current => !current)
    }
   
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
      };
      const widthStyle={
        "width": "94.5%"
      }
  return (
   <>
   
   <h1 className="font-cavaet text-4xl text-center mt-6">More of Me !</h1>
   <p className="font-cavaet text-3xl text-center text-blue-600">Things I love to do when I am not coding / Other than Coding </p>
    <div className="px-4 py-10">
        <Carousel responsive={responsive}>
 
 {data.map((img, i)=>(
   <div className="min-h-full rounded-xl">
     <img onMouseOver={toggleState} src={img.url} key={i} alt={img.text} className="h-[23rem] w-full sm:pl-10 rounded
      hover:animate-pulse" srcset="" />
    {
        state?  
          <p className="font-kalam transition-all duration-1000 translate-x-4 lg:translate-x-20 md:translate-x-12 xl:translate-x-24 -translate-y-52  text-white md:w-80 text-center text-5xl">{img.text}</p>

        :null
    }
   </div>
 ))}
</Carousel>
    </div>
   
   </>
  )
}

export default Slider